import React from 'react';
import { motion } from 'framer-motion';
import { WHY } from '../lib/content';
import { SectionHeading } from './SectionHeading';
export function WhyUs() {
  return <section className="bg-jk-ink py-20" data-id="element-122" data-mp="ssyzmsx8rvr3">
      <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-123" data-mp="17krez4x1d9st">
        <SectionHeading eyebrow="Why Junk Kings" title={<>Treated like <span className="text-jk-red" data-id="element-125" data-mp="12qwlxavjjih2">royalty</span></>} subtitle="We're a young, local crew that shows up on time, works hard, and leaves your space cleaner than we found it." data-id="element-124" data-mp="17lj1zrckhz7h" />
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-126" data-mp="1cij2lmqne9r7">
          {WHY.map((w, i) => <motion.div key={w.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="group rounded-xl border border-white/10 bg-jk-panel p-6 transition-colors hover:border-jk-red/50" data-id="element-127" data-mp="1qghg6px5a25n" data-mpi={i}>
              <div className="font-display text-5xl font-extrabold text-jk-red/30 transition-colors group-hover:text-jk-red/60" data-id="element-128" data-mp="3ec36grr5o0wa">
                {String(i + 1).padStart(2, '0')}
              </div>
              <h3 className="mt-2 font-display text-xl font-bold uppercase text-white" data-id="element-129" data-mp="3naolicxf4xsb">{w.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-130" data-mp="3s3reojyaa57z">{w.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}